module.exports = __webpack_public_path__ + "img/1.04ef4778.png";